import { render, staticRenderFns } from "./qwServiceStaff.vue?vue&type=template&id=3d477205&scoped=true"
import script from "./qwServiceStaff.vue?vue&type=script&lang=js"
export * from "./qwServiceStaff.vue?vue&type=script&lang=js"
import style0 from "./qwServiceStaff.vue?vue&type=style&index=0&id=3d477205&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d477205",
  null
  
)

export default component.exports